import { useMutation } from "react-query";
import { EventParticipationAPI } from "api/eventParticipation";

export default function useUpdateEventParticipationLotOrder() {
  return useMutation(EventParticipationAPI.updateEventParticipationLotOrder);
}
